import React, { ReactNode } from 'react'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/styles'
import Theme from 'core/themes/model'
import colors from 'core/themes/base/colors'
import { healthLableMap } from './helper'

interface CardWithStatusBarProps {
  children: ReactNode
  statusDetails?: {
    unhealthy?: number
    warning?: number
    healthy?: number
    total?: number
  }
  statusName?: string
}

const useStyles = makeStyles<Theme>((theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    padding: '16px 24px',
    gap: '12px',
    background: theme.components.card.background,
    border: `1px solid ${theme.components.card.border}`,
    borderRadius: 4,
    position: 'relative',
  },
  leftBar: {
    position: 'absolute',
    left: 0,
    top: 0,
    bottom: 0,
    width: 6,
    borderRadius: '4px 0 0 4px',
  },
  success: { background: colors.green[80] },
  warning: { background: colors.yellow[500] },
  error: { background: colors.pink[800] },
}))

const CardWithStatusBar = ({ children, statusDetails, statusName }: CardWithStatusBarProps) => {
  const classes = useStyles()
  let leftBarColor =
    statusDetails?.unhealthy !== undefined
      ? statusDetails?.unhealthy > 0
        ? classes.error
        : statusDetails?.warning > 0
        ? classes.warning
        : classes.success
      : statusName === healthLableMap.Unhealthy
      ? classes.error
      : [healthLableMap.Maintenance, healthLableMap.NetworkError].includes(statusName)
      ? classes.warning
      : classes.success

  return (
    <div className={classes.container}>
      <div className={clsx(classes.leftBar, leftBarColor)} />
      {children}
    </div>
  )
}

export default CardWithStatusBar
